import React, { createContext, useContext, useState, useEffect } from 'react';
import { siteContent } from '../data/mock';

const LanguageContext = createContext();

// Supported languages
const LANGUAGES = ['fr', 'en', 'pt'];
const LANGUAGE_NAMES = {
  fr: 'Français',
  en: 'English',
  pt: 'Português'
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('ada-language');
    return saved && LANGUAGES.includes(saved) ? saved : 'fr';
  });

  useEffect(() => {
    localStorage.setItem('ada-language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = siteContent[language] || siteContent['fr'];
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        // Fallback to French if translation not found
        let fallback = siteContent['fr'];
        for (const fk of keys) {
          if (fallback && fallback[fk] !== undefined) {
            fallback = fallback[fk];
          } else {
            return key;
          }
        }
        return fallback;
      }
    }
    return value;
  };

  const cycleLanguage = () => {
    const currentIndex = LANGUAGES.indexOf(language);
    const nextIndex = (currentIndex + 1) % LANGUAGES.length;
    setLanguage(LANGUAGES[nextIndex]);
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      cycleLanguage, 
      t,
      languages: LANGUAGES,
      languageNames: LANGUAGE_NAMES
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
